import { SVGProps } from 'react'

export const WpsQuotaSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      clipRule='evenodd'
      d='M14.36 3.953c.261-.212.358-.451.256-.709-.103-.258-.51-.288-.728-.198-.125.053-.536.307-.748.451-.211.144-.934.667-1.92 1.651-.985.984-2.229 2.808-2.229 4.975l.004-.002v.005A2.876 2.876 0 0011.872 13a2.876 2.876 0 002.878-2.874 2.876 2.876 0 00-2.38-2.832l.004-.004-.051-.007c-.263-.036-.476-.066-.395-.463.075-.364.721-1.443 1.607-2.198.158-.134.364-.299.562-.458l.263-.211zm-7.742 0c.262-.212.359-.451.256-.709-.102-.258-.51-.288-.727-.198-.126.053-.536.307-.748.451-.212.144-.935.667-1.92 1.651-.986.984-2.229 2.808-2.229 4.975l.003-.002v.005A2.876 2.876 0 004.131 13a2.876 2.876 0 002.877-2.874 2.876 2.876 0 00-2.38-2.832l.005-.004-.051-.007c-.264-.036-.476-.066-.395-.463.075-.364.72-1.443 1.607-2.198.157-.134.364-.299.562-.458l.262-.211z'
      fill='#2D343D'
      fillRule='evenodd'
    />
  </svg>
)
